/**
 * Ends partner sessions on an explicit TonConnect UI logout, including on the
 * main app where the partner panel is not mounted.
 */
import { useEffect } from 'react';
import { PARTNER_API_AVAILABLE } from './api';
import { revokePartnerSession } from './session';
import { subscribeToTonConnectUiDisconnection } from './tonConnectDisconnection';

export function usePartnerLogoutOnDisconnect(): void {
  useEffect(() => {
    if (!PARTNER_API_AVAILABLE) return;
    return subscribeToTonConnectUiDisconnection((disconnectedAddress) => {
      revokePartnerSession(disconnectedAddress);
    });
  }, []);
}
